import {Collection} from 'backbone';
import CostOption from '../models/CostOption';

class CostOptions extends Collection.extend({
  model: CostOption
}) {}

export default CostOptions;